import _, { filter } from 'lodash';
import { DataDirection } from '../../../core/types/ui/position';
import {
  Sheet,
  CellPosition,
  Area,
  SheetSelection,
  Row,
  Col,
  Freeze,
  IRange,
  SheetView,
  FilterResults,
  EntitySize,
} from '../../types';
import {
  isAreaInsideArea,
  convertPositionToArea,
  doAreasIntersect,
  isEqualAreas,
} from '../area/area';
// import { getUnHiddenRowCol } from '../viewport/viewportUtils';
import { unionAreaWithMerges } from './merges';
import { getNextVisibleRowCol } from './selection';
import {
  IterateViewportParams,
  getUnHiddenPosition,
  iterateViewportBackward,
  iterateViewportForward,
} from './virtualViewport';
import { convertParsedAddressToArea } from '../address/address';
import { parseSingleAddress } from '../address/singleAddress';

// #region Enter Key Helpers
export const getNextColInSelection = (
  sheet: Sheet,
  sheetView: SheetView,
  activeCell: CellPosition,
  selectionArea: Area,
  selections: SheetSelection[]
) => {
  activeCell.ci = getUnHiddenPosition(
    sheet.colSizes,
    sheet.hiddenCols,
    activeCell.ci,
    sheet.maxColIndex,
    DataDirection.Forward,
    sheet.freezedCols,
    undefined,
    1
  );
  // activeCell.ci = getUnHiddenRowCol(
  //   sheet.cols,
  //   activeCell.ci + 1,
  //   0,
  //   sheet.maxColCount,
  //   DataDirection.Forward,
  //   sheet.freezedCols
  // );

  if (activeCell.ci > selectionArea.end.ci) {
    // Jump back to start
    handleActiveCellLastInSelection(
      sheet,
      sheetView,
      selections,
      activeCell,
      selectionArea
    );
  } else if (!validateTopLeftCellForMerge(sheet.merges, activeCell)) {
    getNextRowInSelection(
      sheet,
      sheetView,
      activeCell,
      selectionArea,
      selections
    );
  }
};

export const getNextRowInSelection = (
  sheet: Sheet,
  sheetView: SheetView,
  activeCell: CellPosition,
  //   activeCellArea: Area,
  selectionArea: Area,
  selections: SheetSelection[]
) => {
  const activeCellArea = unionAreaWithMerges(
    sheet.merges,
    convertPositionToArea(activeCell)
  );

  activeCell.ri = getUnHiddenPosition(
    sheet.rowSizes,
    sheet.hiddenRows,
    activeCellArea.end.ri,
    sheet.maxRowIndex,
    DataDirection.Forward,
    sheet.freezedRows,
    sheetView.filterResults,
    1
  );
  // activeCell.ri = getUnHiddenRowCol(
  //   sheet.rows,
  //   activeCellArea.end.ri + 1,
  //   0,
  //   sheet.maxRowCount,
  //   DataDirection.Forward,
  //   sheet.freezedRows,
  //   sheet.filterResult
  // );
  if (activeCell.ri > selectionArea.end.ri) {
    activeCell.ri = getUnHiddenPosition(
      sheet.rowSizes,
      sheet.hiddenRows,
      selectionArea.start.ri,
      sheet.maxRowIndex,
      DataDirection.Forward,
      sheet.freezedRows,
      sheetView.filterResults,
      0
    );
    // activeCell.ri = getUnHiddenRowCol(
    //   sheet.rows,
    //   selectionArea.start.ri,
    //   0,
    //   sheet.maxRowCount,
    //   DataDirection.Forward,
    //   sheet.freezedRows,
    //   sheet.filterResult
    // );
    // Jump to next col
    getNextColInSelection(
      sheet,
      sheetView,
      activeCell,
      selectionArea,
      selections
    );
  } else if (!validateTopLeftCellForMerge(sheet.merges, activeCell)) {
    getNextRowInSelection(
      sheet,
      sheetView,
      activeCell,
      selectionArea,
      selections
    );
  }
};

function validateTopLeftCellForMerge(
  merges: Area[], //string[],
  newActiveCell: CellPosition
) {
  let isInMerge = false;
  let topLeftCell = false;
  for (let mergeArea of merges) {
    // const mergeArea = convertParsedAddressToArea(
    //   parseSingleAddress(merge),
    //   maxColIndex,
    //   maxRowIndex
    // );
    if (isAreaInsideArea(convertPositionToArea(newActiveCell), mergeArea)) {
      isInMerge = true;
      if (
        newActiveCell.ci === mergeArea.start.ci &&
        newActiveCell.ri === mergeArea.start.ri
      ) {
        topLeftCell = true;
      }

      break;
    }
  }

  return isInMerge ? topLeftCell : true;
}

function handleActiveCellLastInSelection(
  sheet: Sheet,
  sheetView: SheetView,
  newSelections: SheetSelection[],
  newActiveCell: CellPosition,
  area: Area
) {
  if (newSelections.length > 1) {
    jumpToFirstCellInFirstSelection(newSelections, newActiveCell);
  } else {
    resetActiveCellToStartOfArea(newActiveCell, area);
  }

  const { ri, ci } = getNextVisibleRowCol(
    sheet,
    newActiveCell.ci,
    newActiveCell.ri,
    sheetView.filterResults,
    0
  );
  newActiveCell.ci = ci;
  newActiveCell.ri = ri;
}

function jumpToFirstCellInFirstSelection(
  newSelections: SheetSelection[],
  newActiveCell: CellPosition
): void {
  const firstSelectionArea = newSelections[0].area;
  newActiveCell.ci = firstSelectionArea.start.ci;
  newActiveCell.ri = firstSelectionArea.start.ri;

  moveFirstSelectionToLast(newSelections);
}

function moveFirstSelectionToLast(array: SheetSelection[]) {
  const firstElement = array.shift();
  if (firstElement) array.push(firstElement);
}

function resetActiveCellToStartOfArea(
  activeCell: CellPosition,
  area: Area
): void {
  activeCell.ci = area.start.ci;
  activeCell.ri = area.start.ri;
}

// export const jumpBetweenMergesForward = (
//   merges: Area[],
//   area: Area,
//   expPos: number,
//   // activePos: number,
//   alias: 'ci' | 'ri'
// ): number => {
//   let expectedNextPos = expPos;

//   merges.forEach((merge) => {
//     if (doAreasIntersect(merge, area)) {
//       const newIdx = merge.end[alias];
//       expectedNextPos = Math.max(newIdx, expectedNextPos);
//     }
//   });

//   if (expectedNextPos !== expPos) {
//     return jumpBetweenMergesForward(
//       merges,
//       area,
//       expectedNextPos,
//       // activePos,
//       alias
//     );
//   }

//   return expectedNextPos;
// };
// #endregion

// #region forward position index with keys
type ChangedRange = 'start' | 'end';

export interface ArrowKeysPositionReturnType {
  idx: number;
  correspondingIndex?: number;
  range: IRange;
}

interface ArrowKeyPositionHelperReturnType {
  newIndex: number;
  correspondingIndex?: number;
  changedRange: ChangedRange;
}

/*
  Step 1# Select expectedIndex to selectionArea.start[alias] (i.e: ci | ri)
  Step 2# Create a temporarySheets area with expected index to check if merge intersects area
  Step 3# Check if equal areas set activeCellArea to visible cell(in case of hidden and filter) This check will be used to get actual visible start to jump index
  Step 4# If are intersects set expectedNextIndex to area end
  Step 5# Now find nextIndex using unHiddenPosition
  Step 6# If nextIndex is greater than activeCellArea.start[alias] then find the next position from selection end (i.e:  selectionArea.start[alias])
  Step 7# After validation now call generateForwardPosition to get index & corresponding index by jumping merge cells
*/

export const setForwardPositionIndex = (
  selectionArea: Area,
  cellArea: Area,
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  alias: 'ci' | 'ri',
  max: number,
  sheet: Sheet, //merges: Area[],
  shiftKey: boolean,
  freeze: Freeze,
  filterResults?: FilterResults,
  expectedIdx?: number,
  changedRange: ChangedRange = 'start'
): ArrowKeysPositionReturnType => {
  let activeCellArea = _.cloneDeep(cellArea);
  // const nextIdx =
  //   expectedIdx !== undefined
  //     ? expectedIdx + 1
  //     : selectionArea.start[alias] + 1;

  let expectedNextIdx =
    expectedIdx !== undefined ? expectedIdx : selectionArea.start[alias];

  // If area is inside merge then set it to merge end
  if (shiftKey) {
    const area: Area = _.cloneDeep(selectionArea);
    area.start[alias] = expectedNextIdx;
    area.end[alias] = expectedNextIdx;
    let mergeExpPos: number | undefined;
    for (const mergeArea of sheet.merges) {
      // const mergeArea = convertParsedAddressToArea(
      //   parseSingleAddress(merge),
      //   sheet.maxColIndex,
      //   sheet.maxRowIndex
      // );
      if (isEqualAreas(mergeArea, activeCellArea)) {
        activeCellArea = getVisibleMerge(
          entitySizes,
          hiddenRanges,
          freeze,
          mergeArea,
          area,
          changedRange,
          alias,
          filterResults
        );
      }
      if (doAreasIntersect(mergeArea, area)) {
        if (mergeExpPos == undefined) mergeExpPos = mergeArea.end[alias];
        else mergeExpPos = Math.max(mergeArea.end[alias], mergeExpPos);
      }
    }
    if (mergeExpPos !== undefined) expectedNextIdx = mergeExpPos;
  }

  const nextIdx = getUnHiddenPosition(
    entitySizes,
    hiddenRanges,
    expectedNextIdx,
    max,
    DataDirection.Forward,
    freeze,
    filterResults,
    1
  );

  if (nextIdx > activeCellArea.start[alias] && expectedIdx === undefined) {
    return setForwardPositionIndex(
      selectionArea,
      activeCellArea,
      entitySizes,
      hiddenRanges,
      alias,
      max,
      sheet,
      shiftKey,
      freeze,
      filterResults,
      selectionArea.end[alias],
      'end'
    );
  }

  const results = generateForwardPosition(
    entitySizes,
    hiddenRanges,
    selectionArea,
    activeCellArea,
    alias,
    max,
    sheet,
    shiftKey,
    nextIdx,
    changedRange,
    freeze,
    filterResults
  );

  let idx = results.newIndex;

  const range: IRange = { start: idx, end: idx };
  // If start is changed then end will remains the old area end
  if (results.changedRange === 'start') {
    range.end = selectionArea.end[alias];
  } else {
    range.start = selectionArea.start[alias];
  }

  return {
    idx,
    correspondingIndex: results.correspondingIndex,
    range,
  };
};

const generateForwardPosition = (
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  selectionArea: Area,
  cellArea: Area,
  alias: 'ci' | 'ri',
  max: number,
  sheet: Sheet, //merges: Area[],
  shiftKey: boolean,
  nextIdx: number,
  changedRange: ChangedRange,
  freeze: Freeze,
  filterResults?: FilterResults
): ArrowKeyPositionHelperReturnType => {
  const opAlias = alias === 'ci' ? 'ri' : 'ci';
  let expectedIdx = nextIdx;

  const area: Area = _.cloneDeep(selectionArea);
  if (!shiftKey) {
    area.end[opAlias] = area.start[opAlias];
  }
  area.start[alias] = expectedIdx;
  area.end[alias] = expectedIdx;

  const { isCoincide, mergedArea } = doMergeCoincide(
    entitySizes,
    hiddenRanges,
    freeze,
    sheet,
    area,
    'start',
    alias,
    filterResults
  );

  if (!isCoincide) {
    // let selectionEnd = selectionArea.end[alias] + 1;
    let selectionEnd = getUnHiddenPosition(
      entitySizes,
      hiddenRanges,
      selectionArea.end[alias],
      max,
      DataDirection.Forward,
      freeze,
      filterResults,
      1
    );
    let newChangedRange: ChangedRange = 'end';
    if (mergedArea) {
      // const mergeEnd = mergedArea.end[alias] + 1;
      let mergeEnd = getUnHiddenPosition(
        entitySizes,
        hiddenRanges,
        mergedArea.end[alias],
        max,
        DataDirection.Forward,
        freeze,
        filterResults,
        1
      );
      const cellAreaEnd = cellArea.end[alias];
      if (mergeEnd <= cellAreaEnd) {
        selectionEnd = mergeEnd;
        newChangedRange = 'start';
      }
    }

    if (selectionEnd == nextIdx)
      return {
        newIndex: nextIdx,
        changedRange,
      };

    return generateForwardPosition(
      entitySizes,
      hiddenRanges,
      selectionArea,
      cellArea,
      alias,
      max,
      sheet,
      shiftKey,
      selectionEnd,
      newChangedRange,
      freeze,
      filterResults
    );
  } else if (!shiftKey && mergedArea) {
    // we need top left position of cell to be fit on viewport (must be without shift key)
    return {
      newIndex: mergedArea.start[alias],
      correspondingIndex: mergedArea.start[opAlias],
      changedRange,
    };
  }

  return {
    newIndex: nextIdx,
    changedRange,
  };
};

// #endregion

// #region backward position index
export const setBackwardPositionIndex = (
  selectionArea: Area,
  cellArea2: Area,
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  alias: 'ci' | 'ri',
  max: number,
  sheet: Sheet, // merges: string[], //Area[],
  shiftKey: boolean,
  freeze: Freeze,
  filterResults?: FilterResults,
  expectedIdx?: number,
  changedRange: ChangedRange = 'end'
): ArrowKeysPositionReturnType => {
  const { merges, maxColIndex, maxRowIndex } = sheet;
  let activeCellArea = _.cloneDeep(cellArea2);

  let expectedPos =
    expectedIdx !== undefined ? expectedIdx : selectionArea.end[alias];

  // If area is inside merge then set it to merge start
  // if (shiftKey) {
  const area: Area = _.cloneDeep(selectionArea);
  area.start[alias] = expectedPos;
  area.end[alias] = expectedPos;
  let mergeExpPos: number | undefined;
  for (const mergeArea of merges) {
    // const mergeArea = convertParsedAddressToArea(
    //   parseSingleAddress(merge),
    //   maxColIndex,
    //   maxRowIndex
    // );
    if (doAreasIntersect(mergeArea, area)) {
      if (mergeExpPos == undefined) mergeExpPos = mergeArea.start[alias];
      else mergeExpPos = Math.min(mergeArea.start[alias], mergeExpPos);
    }
  }
  if (mergeExpPos !== undefined) expectedPos = mergeExpPos;
  // }

  const prevIdx = getUnHiddenPosition(
    entitySizes,
    hiddenRanges,
    expectedPos,
    max,
    DataDirection.Backward,
    freeze,
    filterResults,
    1
  );

  // const prevIdx =
  // expectedIdx !== undefined ? expectedIdx - 1 : selectionArea.end[alias] - 1;

  if (prevIdx < activeCellArea.start[alias] && expectedIdx === undefined) {
    // oldCondition: prevIdx < activeCellArea.end[alias]
    return setBackwardPositionIndex(
      selectionArea,
      activeCellArea,
      entitySizes,
      hiddenRanges,
      alias,
      max,
      sheet,
      shiftKey,
      freeze,
      filterResults,
      selectionArea.start[alias],
      'start'
    );
  }

  const results = generateBackwardPosition(
    entitySizes,
    hiddenRanges,
    selectionArea,
    activeCellArea,
    alias,
    max,
    sheet,
    prevIdx,
    changedRange,
    shiftKey,
    freeze,
    filterResults
  );

  let idx = results.newIndex;
  const range: IRange = { start: idx, end: idx };
  if (results.changedRange === 'start') {
    range.end = selectionArea.end[alias];
  } else {
    range.start = selectionArea.start[alias];
  }

  return {
    idx,
    correspondingIndex: results.correspondingIndex,
    range,
  };
};

const generateBackwardPosition = (
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  selectionArea: Area,
  cellArea: Area,
  alias: 'ci' | 'ri',
  max: number,
  sheet: Sheet, //merges: Area[],
  prevIdx: number,
  changedRange: ChangedRange,
  shiftKey: boolean,
  freeze: Freeze,
  filterResults?: FilterResults
): ArrowKeyPositionHelperReturnType => {
  const opAlias = alias === 'ci' ? 'ri' : 'ci';
  let expectedIdx = prevIdx;

  const area: Area = _.cloneDeep(selectionArea);
  // const newArea = shiftKey ? area :
  if (!shiftKey) {
    // This check is for merged cell if no shift key is pressed therfore restricts the op position (ri | ci) to top
    area.end[opAlias] = area.start[opAlias]; // Set to top left cell
    // area.start[opAlias] = area.start[opAlias]
  }
  area.start[alias] = expectedIdx;
  area.end[alias] = expectedIdx;

  const { isCoincide, mergedArea } = doMergeCoincide(
    entitySizes,
    hiddenRanges,
    freeze,
    sheet,
    area,
    'end',
    alias,
    filterResults
  );

  if (!isCoincide) {
    // -1 Because Backward
    // let selectionStart = selectionArea.start[alias] - 1;
    let selectionStart = getUnHiddenPosition(
      entitySizes,
      hiddenRanges,
      selectionArea.start[alias],
      max,
      DataDirection.Backward,
      freeze,
      filterResults,
      1
    );
    let newChangedRange: ChangedRange = 'start';
    if (mergedArea) {
      // const mergedStart = mergedArea.start[alias] - 1;
      const mergedStart = getUnHiddenPosition(
        entitySizes,
        hiddenRanges,
        mergedArea.start[alias],
        max,
        DataDirection.Backward,
        freeze,
        filterResults,
        1
      );
      const cellAreaStart = cellArea.start[alias];
      if (mergedStart >= cellAreaStart) {
        selectionStart = mergedStart;
        newChangedRange = 'end';
      }
    }

    if (prevIdx === selectionStart)
      return {
        newIndex: prevIdx,
        changedRange,
      };

    return generateBackwardPosition(
      entitySizes,
      hiddenRanges,
      selectionArea,
      cellArea,
      alias,
      max,
      sheet,
      selectionStart,
      newChangedRange,
      shiftKey,
      freeze,
      filterResults
    );
  } else if (!shiftKey && mergedArea) {
    // we need top left position of cell to be fit on viewport (must be without shift key)
    return {
      newIndex: mergedArea.start[alias],
      correspondingIndex: mergedArea.start[opAlias],
      changedRange,
    };
  }

  return {
    newIndex: prevIdx,
    changedRange,
  }; //idx;
};

// This function will help in deciding either to generate index less than area start
// or area end
export const doMergeCoincide = (
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  freeze: Freeze,
  sheet: Sheet, //merges: string[], //Area[],
  area: Area,
  posAlias: 'start' | 'end',
  alias: 'ci' | 'ri',
  filterResults?: FilterResults
): {
  mergedArea?: Area;
  isCoincide: boolean;
} => {
  const { merges, maxColIndex, maxRowIndex } = sheet;
  for (let mergeArea of merges) {
    // const mergeArea = convertParsedAddressToArea(
    //   parseSingleAddress(merge),
    //   maxColIndex,
    //   maxRowIndex
    // );
    if (doAreasIntersect(mergeArea, area)) {
      //Get merge area without hidden rows and filter (the exact merge that will be visible in viewport)
      const visibleMerge = getVisibleMerge(
        entitySizes,
        hiddenRanges,
        freeze,
        mergeArea,
        area,
        posAlias,
        alias,
        filterResults
      );
      return {
        mergedArea: visibleMerge,
        isCoincide: visibleMerge[posAlias][alias] === area[posAlias][alias],
      };
    }
  }

  return {
    isCoincide: true,
  };
};

const getVisibleMerge = (
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  freezed: Freeze,
  merge: Area,
  area: Area,
  posAlias: 'start' | 'end',
  alias: 'ci' | 'ri',
  filterResults?: FilterResults
) => {
  const visibleMerge = _.cloneDeep(merge);
  const rowCB = ({ index }: IterateViewportParams) => {
    if (index > merge.end[alias] || index < merge.start[alias]) return true;

    visibleMerge[posAlias][alias] = index;
    return false;
  };

  if (posAlias === 'start') {
    iterateViewportBackward(
      merge[posAlias][alias],
      area[posAlias][alias],
      entitySizes,
      hiddenRanges,
      rowCB,
      freezed,
      10, // any random size
      1, // any random zoom
      filterResults
    );
  } else {
    iterateViewportForward(
      area[posAlias][alias],
      merge[posAlias][alias],
      entitySizes,
      hiddenRanges,
      rowCB,
      freezed,
      10,
      1,
      filterResults
    );
  }
  return visibleMerge;
};

export const jumpBetweenMergesBackward = (
  merges: Area[],
  area: Area,
  expPos: number,
  cellAreaStart: number,
  alias: 'ci' | 'ri'
): number => {
  let expectedPrevPos = expPos;

  merges.forEach((merge) => {
    if (doAreasIntersect(merge, area)) {
      expectedPrevPos = Math.min(merge.start[alias], expectedPrevPos);
    }
  });

  if (expectedPrevPos !== expPos) {
    return jumpBetweenMergesBackward(
      merges,
      area,
      expectedPrevPos,
      cellAreaStart,
      alias
    );
  }

  return expectedPrevPos;
};
// #endregion
